<template>
  <div id="app" class="app">
    <router-view />

    <va-modal
      v-model="modal"
      size="small"
      class="mb-1"
      :title="'แจ้งเตือน'"
      :message="modalMessage == '' ? 'กรุณาลองใหม่อีกครั้ง' : modalMessage"
      :okText="'ตกลง'"
      :cancelText="'ปิด'"
      :cancel="confirmModal"
    />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      // Temporary config for 2.1.
      contextConfig: {
        gradient: true,
        shadow: "lg", // 3 states: 'sm', 'lg', undefined (no shadow).
        invertedColor: false
      },
      modal: false,
      modalMessage: ""
    };
  },
  provide() {
    return {
      contextConfig: this.contextConfig
    };
  },
  methods: {
    confirmModal() {}
  },
  watch: {
    "$store.state.modal": {
      async handler(modal) {
        if (modal.status == true) {
          this.modalMessage = modal.message;

          this.modal = modal.status;
        } else {
          this.modal = false;
        }
      }
    }
    // Temporary colors fix for 2.1.
    // "contextConfig.invertedColor"(val) {
    //   const invertedColorClass = "va-inverted-color";
    //   if (val) {
    //     document.body.classList.add(invertedColorClass);
    //   } else {
    //     document.body.classList.remove(invertedColorClass);
    //   }
    // }
  }
};
</script>

<style lang="scss">
@import "../sass/main.scss";

body {
  height: 115%;
  #app {
    height: 100%;
  }
}

body::selection,
html::selection,
head::selection {
  background-color: $color--base;
}
</style>

<style>
.text-note {
  color: gray;
  font-size: smaller;
}
</style>

<style lang="scss" scoped>
::v-deep .va-modal--mobile-fullscreen {
  min-height: auto !important;
  min-width: auto !important;
  border-radius: 5px;
}
</style>
